<template>
  <button :class="['p-button p-component',
    { 'p-button-success': type === 'success' },
    { 'p-button-loading': loading }
  ]" :type="buttonType" @click="handleClick" :disabled="disabled || loading">
    <span v-if="loading" class="spinner">
      <i class="pi pi-spin pi-spinner"></i>
    </span>
    <span v-else-if="icon" :class="['pi', icon]"></span>
    <span v-if="label" class="p-button-label">{{ label }}</span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'button'
    },
    buttonType: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    handleClick(event) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', event);
      }
    }
  }
}
</script>

<style scoped>
.p-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #f8f9fa;
  height: 38px;
  margin-top: 20px;
  color: #212529;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s;
}

.p-button:hover:not(:disabled):not(.p-button-loading) {
  background-color: #e9ecef;
}

.p-button-success {
  background-color: #28a745;
  color: #ffffff;
  border-color: #28a745;
}

.p-button-success:hover:not(:disabled):not(.p-button-loading) {
  background-color: #218838;
  border-color: #1e7e34;
}

.p-button:disabled,
.p-button.p-button-loading {
  opacity: 0.6;
  cursor: default;
  pointer-events: none;
}

.pi {
  margin-right: 0.5rem;
}

/* Spinner animation */
.spinner {
  margin-right: 0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.pi-spin {
  animation: spin 1s linear infinite;
}

/* Estilo mejorado para botón con carga */
.p-button-loading {
  position: relative;
  overflow: hidden;
}

.p-button-loading:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: loading-sweep 1.5s infinite;
}

@keyframes loading-sweep {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

/* Mejorar la legibilidad del texto durante la carga */
.p-button-loading .p-button-label {
  opacity: 0.9;
}
</style>
